/**
 * Guard for portal routes. Redirects unauthenticated users to /portal/login.
 *
 * Keeps a short-lived check against localStorage (synchronous) so a hard
 * refresh on a deep portal URL doesn't flash the protected page before
 * the token check resolves.
 */
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { isPortalAuthenticated } from '@/api/portal'

interface Props {
  children: ReactNode
}

export default function PortalProtectedRoute({ children }: Props) {
  const location = useLocation()
  if (!isPortalAuthenticated()) {
    return (
      <Navigate
        to="/portal/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    )
  }
  return <>{children}</>
}
